// extracted by mini-css-extract-plugin
export default {"contentModal":"NoWirelessWarnModal_contentModal__H4miE","textModal":"NoWirelessWarnModal_textModal__EDfJa"};